/**
 * แปลง ISO string เป็นวันเวลาแบบภาษาไทย
 * เช่น "2024-01-17T06:28:22Z" → "วันพุธที่ 17 มกราคม พ.ศ. 2567 เวลา 13:28"
 */
export function formatThaiDateTime(isoString: string): string {
	const date = new Date(isoString);

	const optionsDate: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
		timeZone: 'Asia/Bangkok',
	};

	const optionsTime: Intl.DateTimeFormatOptions = {
		hour: '2-digit',
		minute: '2-digit',
		hour12: false,
		timeZone: 'Asia/Bangkok',
	};

	const dateTH = new Intl.DateTimeFormat('th-TH', optionsDate).format(date);
	const timeTH = new Intl.DateTimeFormat('th-TH', optionsTime).format(date);

	return `${dateTH} เวลา ${timeTH}`;
}
